import { create } from 'zustand'

export interface BrandingConfig {
  name: string
  logoUrl: string
  primaryColor: string
}

function hexToHsl(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16) / 255
  const g = parseInt(hex.slice(3, 5), 16) / 255
  const b = parseInt(hex.slice(5, 7), 16) / 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h = 0
  let s = 0
  const l = (max + min) / 2

  if (max !== min) {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break
      case g: h = ((b - r) / d + 2) / 6; break
      case b: h = ((r - g) / d + 4) / 6; break
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`
}

interface BrandingState extends BrandingConfig {
  applyToDocument: () => void
}

export const useBrandingStore = create<BrandingState>((set, get) => ({
  name: 'ScopeAssistant',
  logoUrl: '',
  primaryColor: '#8b1a1a',

  applyToDocument: () => {
    const { primaryColor } = get()
    if (primaryColor.startsWith('#')) {
      document.documentElement.style.setProperty(
        '--brand-primary',
        hexToHsl(primaryColor)
      )
    }
  },
}))
